export enum AssignType {
  INITIATORY_BRIEFING = 'initiatory_briefing',
  RE_BRIEFING = 're_briefing',
  INITIAL_BRIEFING = 'initial_briefing',
  UNSCHEDULED_BRIEFING = 'unscheduled_briefing',
  TARGETED_BRIEFING = 'targeted_briefing',
  SCHEDULED_TRAINING = 'scheduled_training',
  UNSCHEDULED_TRAINING = 'unscheduled_training',
}
